var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileAltSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 96v832h640V307.008l-8.992-10.016-192-192L620.992 96z m64 64h320v192h192v512H256z m384 46.016L722.016 288H640zM352 416v64h320v-64z m0 128v64h320v-64z m0 128v64h320v-64z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAltSolid);
export default __webpack_public_path__ + "static/media/file-alt-solid.7e3150bba871eca160f6c30e156dd166.svg";
export { ForwardRef as ReactComponent };